import {
    getPaymentProfile,
    listPaymentProfiles
} from './queries';
import {
    createPaymentProfile,
    deletePaymentProfile,
    updatePaymentProfile,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {PaymentProfile} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


export type ListPaymentProfiles = {
    listPaymentProfiles: { items: PaymentProfile[], nextToken: string }
}

export type GetPaymentProfile = {
    getPaymentProfile: PaymentProfile
}

export type CreatePaymentProfile = {
    createPaymentProfile: PaymentProfile
}

export type UpdatePaymentProfile = {
    updatePaymentProfile: PaymentProfile
}

export type DeletePaymentProfile = {
    deletePaymentProfile: string
}


const client = billingApiClient;


export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListPaymentProfiles>>({
                                                                                 query: listPaymentProfiles,
                                                                                 variables: {
                                                                                     ...query
                                                                                 },
                                                                             });
    return {
        items: response.data?.listPaymentProfiles.items,
        nextToken: response.data?.listPaymentProfiles.nextToken
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPaymentProfile>>({
                                                                               query: getPaymentProfile,
                                                                               variables: {id: id},
                                                                           });
    return response.data?.getPaymentProfile;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreatePaymentProfile>>({
                                                                                  query: createPaymentProfile,
                                                                                  variables: {input: payload},
                                                                              });
    return response.data?.createPaymentProfile;
};

export const update = async (_id: string, record: PaymentProfile) => {
    const {
        createdByUsername: _createdByUsername,
        created: _created,
        updated: _updated,
        billingProvider: _billingProvider,
        customer: _customer,
        ...rest
    } = record

    const response = await client.graphql<GraphQLQuery<UpdatePaymentProfile>>({
                                                                                  query: (updatePaymentProfile),
                                                                                  variables: {input: rest},
                                                                              });
    return response.data?.updatePaymentProfile;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeletePaymentProfile>>({
                                                                                  query: (deletePaymentProfile),
                                                                                  variables: {input: {id: id}},

                                                                              });
    return response.data?.deletePaymentProfile;
};
